// Module
var code = "<div class=\"email-body\"> <div id=\"ckeditorEmailBody\" ckeditor=\"vm.editorOptions\" ng-model=\"vm.body\" ng-change=\"vm.onUpdate({body: vm.body})\"></div> </div> ";
// Exports
module.exports = code;